import { Button, Checkbox, Col, Form, Input, notification, Radio, Row, Select } from "antd"
import { useEffect, useState } from "react";
import { addPhenotypeQuestionApi, listOfQuestionDomainApi, updatePhenotypeQuestionApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE, PHONE_PATTERN } from "../../../../../config/constant";
import '../style/PhenoTypeQuestions.scss'
import { FilterApiData } from "../../../../../services/FilterApiData";


export const AddPhenotypeQuestions = (props) => {
    const [form] = Form.useForm();
    const { Option } = Select;

    const [domainValue, setDomainValue] = useState()
    const [domainOptions, setDomainOptions] = useState([])

    useEffect(() => {
        getListOfDomainOptions()
    },[])
    

    const getListOfDomainOptions = () => {
        listOfQuestionDomainApi()
            .then((res) => {
                if (res.status === 200) {
                    setDomainOptions(FilterApiData(res.data.data));
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }


    // console.log('editQuestion',props.editQuestion);
    useEffect(() => {
        
        let editQuestionData = props.editQuestionData
        if(props?.editQuestionData?.question_domain_id){

            setDomainValue(props.editQuestionData.question_domain_id)
        }
        // console.log(props.editQuestionData);
        if (props.editQuestion) {
            form.setFieldsValue({
                'domain': editQuestionData?.question_domain?.domain,
                'question': editQuestionData.question,
                'kapha': editQuestionData.kapha,
                'pitta': editQuestionData.pitta,
                'vata': editQuestionData.vata
            })
        }
    }, [props.editQuestionData])
    // const domainOptions = [
    //     { id: '1', name: "Lifestyle" },
    //     { id: '2', name: "Activity" },
    //     { id: '3', name: "Body Frame" },
    //     { id: '4', name: "Body Temperature" },
    //     { id: '5', name: "Appetite" },
    //     { id: '6', name: "Bowel Movement" },
    //     { id: '7', name: "Digestion" },
    //     { id: '8', name: "Hair" },
    // ];


    const onFinish = (values) => {
        // console.log(values);

        // find domain name from its id 
        // const domainData = domainOptions.find((element) => element.id == values.domain)
        // console.log(domainData);


        if (!props.editQuestion) {
            const data = {
                // "question_domain_id": parseInt(domainData.id),
                "question_domain_id": domainValue,
                "question": values.question,
                "kapha": values.kapha,
                "pitta": values.pitta,
                "vata": values.vata,
                "status": true,
            }
            // console.log(data)

            addPhenotypeQuestionApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'domain': '' })
                        form.setFieldsValue({ 'question': '' })
                        form.setFieldsValue({ 'kapha': '' })
                        form.setFieldsValue({ 'pitta': '' })
                        form.setFieldsValue({ 'vata': '' })
                        notification.success({
                            message: "Question added successfully",
                        });
                        props.setUpdateQuestionList(!props.updateQuestionList)
                        // console.log(props.updateQuestionList);
                        // getListOfDiseases()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const updatedObject = {
                // "question_domain_id": parseInt(domainData.id),
                "question_domain_id": domainValue,
                "question": values.question,
                "kapha": values.kapha,
                "pitta": values.pitta,
                "vata": values.vata,
                "status": props.editQuestionData.status
            }
            // console.log('updatedObject',updatedObject);
            updatePhenotypeQuestionApi(props.editQuestionData.id, updatedObject)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: "Question Update successfully",
                        });
                        form.setFieldsValue({ 'domain': '' })
                        form.setFieldsValue({ 'question': '' })
                        form.setFieldsValue({ 'kapha': '' })
                        form.setFieldsValue({ 'pitta': '' })
                        form.setFieldsValue({ 'vata': '' })
                        props.setUpdateQuestionList(!props.updateQuestionList)
                        props.setEditQuestion(false)
                        // console.log(updateQuestionList);

                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };
    return (

        <div className="AddPhenotypeQuestions">
            <Form
                name="AddPhenotypeQuestionsForm"
                className="AddPhenotypeQuestionsForm"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 2 }]} className="align-self-center">
                    <Col xs={24} md={16} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Domain
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="domain"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Domain!",
                                },
                            ]}
                            initialValue=""
                        >
                            <Select
                                showSearch
                                placeholder="Select Domain"
                                className="w-100 mt-2 p-1"
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                onChange={(e)=>setDomainValue(e)}
                            >
                                <Option value="" hidden disabled>Select Domain</Option>
                                {domainOptions.map(option => (
                                    <Option value={option.id} key={option.id}>{option.domain}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        {/* <label className="form-input-label">
                            Herb Name
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item name="herb_name" rules={[
                            {
                                required: true,
                                message: "Please Enter Herb Name!",
                            },
                        ]}>
                            <Input placeholder="Enter Name" className="mt-2 p-2" />
                        </Form.Item> */}
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={16}>
                        <label className="form-input-label">
                            Question
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="question"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Question!",
                                },
                            ]}
                        >
                            <Input.TextArea placeholder="Enter Question" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Kapha
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="kapha"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Kapha Answer!",
                                },
                            ]}
                        >
                            <Input.TextArea placeholder="Enter Kapha Answer" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Pitta
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="pitta"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Pitta Answer!",
                                },
                            ]}
                        >
                            <Input.TextArea placeholder="Enter Pitta Answer" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Vata
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="vata"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Vata Answer!",
                                },
                            ]}
                        >
                            <Input.TextArea placeholder="Enter Vata Answer" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={16} xl={24} xxl={24} className="align-self-center text-center">
                        <Button htmlType="submit" className="submit-btn border-0 rounded ">
                            {props.editQuestion ? 'Update' : 'Save'}
                        </Button>
                        <Button onClick={() => resetData()} className="reset-btn ms-3 b-0 rounded">
                            RESET
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div >
    )
}